export const PLAN_CATEGORIES = {
  FREE: 'free',
  PAID: 'paid',
  BYOK: 'byok'
};

export const FREE_BYOK_DAILY_LIMIT = 100;

export const getPlanCategory = (userPlan) => {
  if (!userPlan || userPlan === 'free') {
    return PLAN_CATEGORIES.FREE;
  }

  if (userPlan === 'BYOK' || userPlan === 'unlimited_package') {
    return PLAN_CATEGORIES.BYOK;
  }

  const paidPlans = [
    'Starter',
    'Growth',
    'Pro',
    'Agency',
    'Scale',
    'Small',
    'Medium',
    'Large',
    'Ultimate'
  ];

  if (paidPlans.includes(userPlan)) {
    return PLAN_CATEGORIES.PAID;
  }

  return PLAN_CATEGORIES.FREE;
};

const getFreeByokUsageState = (user) => {
  const rawState = user?.freeByokDailyUsage;
  const today = new Date().toISOString().slice(0, 10);
  const reserved = Object.values(
    user?.metadataReservations && typeof user.metadataReservations === 'object'
      ? user.metadataReservations
      : {}
  ).reduce((sum, reservation) => {
    if (reservation?.mode !== 'free_byok' || reservation?.dayKey !== today) return sum;
    if (Number(reservation?.expiresAtMs || 0) <= Date.now()) return sum;
    return sum + Math.max(0, Number(reservation?.amount || 0));
  }, 0);

  return {
    count: rawState && typeof rawState === 'object' && rawState.date === today
      ? Math.max(0, Number(rawState.count || 0))
      : 0,
    reserved
  };
};

export const getFreeByokRemaining = (user) => {
  const state = getFreeByokUsageState(user);
  return Math.max(0, FREE_BYOK_DAILY_LIMIT - state.count - state.reserved);
};
